<template>
  <div class="container push-top">
    <loading-indicator v-if="modules === false"></loading-indicator>
    <div class="no-modules" v-if="modules !== false && modules.length <= 0">
      <img src="/images/sad.png">
      <h3>{{ $t('modules.no_modules_msg_title') }}</h3>
      <p>{{ $t('modules.no_modules_msg_body') }}</p>
      <router-link to="/a/module/new" class="button is-primary is-large">
        {{ $t('modules.create_module') }}
      </router-link>
    </div>
    <div class="columns" v-if="modules.length > 0">
      <div class="column is-12">
        <router-link class="button is-primary is-medium is-pulled-right" to="/a/module/new">
          {{ $t('modules.new_module') }}
        </router-link>
        <h2 class="is-pulled-left">{{ $t('navigation.modules') }}</h2>
      </div>
    </div>
    <div class="container">
      <ul class="modules">
        <transition-group leave-active-class="animated zoomOut">
          <module-line-item :module="module" v-for="module in modules" @delete="deleteModule"
            :key="module.id"></module-line-item>
        </transition-group>
      </ul>
    </div>
  </div>
</template>

<script>
import API from 'mixins/api';
import ModuleLineItem from './partials/module-line-item.vue';

export default {
  mixins: [API],
  components: {
    ModuleLineItem,
  },
  created() {
    this.api().fetchTeamModules()
      .then(modules => this.modules = modules);
  },
  data() {
    return {
      modules: false,
    }
  },
  methods: {
    deleteModule(module) {
      this.modules = _.without(this.modules, module);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.no-modules {
  width: 400px;
  background: $white;
  text-align: center;
  padding: 40px;
  border-radius: 2px;
  display: block;
  margin: 200px auto;
  border: 1px solid lighten($mutedblue, 12%);
  img {
    width: 60px;
    display: block;
    margin: 0 auto 26px;
  }
  h3 {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0 0 20px;
    letter-spacing: 1px;
  }
  p {
    margin-bottom: 25px;
  }
}

a.button {
  margin-top: -4px;
}

ul.modules {
  margin: 20px 0 40px;
}
</style>



// WEBPACK FOOTER //
// Modules.vue?29f01844